import React, {Component} from "react";

export default class Email extends Component {
  render() {
    return (
      <a href="mailto:contact@murrahhall.net.au">contact@murrahhall.net.au</a>
    );
  }
}
